import { render, staticRenderFns } from "./UserSingle.vue?vue&type=template&id=524c349b&"
import script from "./UserSingle.vue?vue&type=script&lang=js&"
export * from "./UserSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports